<template>
  <!-- <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    :data-target="target"
    :aria-controls="target"
    :aria-expanded="toggled"
    aria-label="Toggle navigation"
  >
    <slot>
      <span></span>
      <span></span>
    </slot>
  </button> -->
  <div
    :data-target="target"
    :aria-controls="target"
    :aria-expanded="toggled"
    class="sidenav-toggler d-xl-block active"
  >
    <div class="sidenav-toggler-inner">
      <slot>
        <i class="sidenav-toggler-line"></i>
        <i class="sidenav-toggler-line"></i>
        <i class="sidenav-toggler-line"></i>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    target: {
      type: [String, Number],
      description: "Button target element"
    },
    toggled: {
      type: Boolean,
      default: false,
      description: "Whether button is toggled"
    }
  }
};
</script>
<style></style>
